<template>
    <v-container>
        <div v-if="!fetchLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Landed Cost</h4>
                    <p class="text-subtitle-1">Landed Cost Modification Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <LandedCostForm ref="form" v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block :loading="loading" @click="handleSave">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </v-container>
</template>

<script>
import LandedCostForm from '../../components/purchase/LandedCostForm.vue';
import landedCost from '../../services/purchase/landedCost';
import PAlert from '../../components/common/PAlert.vue';

export default {
    components: {
        LandedCostForm,
        PAlert
    },
    data() {
        return {
            id: null,
            data: {},
            loading: false,
            fetchLoading: false,
            alert: {
                display: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
        }
    },
    methods: {
        fetch() {
            this.fetchLoading = true;
            landedCost.find(this.id).then(res => {
                let d = res.data;
                this.data = {
                    ...d,
                    warehouse_id: d.warehouse.id,
                    components: d.component_lines.map(line => {
                        return {
                            ...line,
                            component_id: line.component.id,
                        }
                    }),
                    items: d.lines.map(line => {
                        return {
                            ...line,
                            item_id: line.item.id,
                            measure_unit_id: line.measure_unit.id
                        }
                    })
                }
            }).finally(() => {
                this.fetchLoading = false;
            })
        },
        handleCancel() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to discard changes?", callback: this.cancel };
        },
        cancel() {
            this.$router.back();
        },
        handleSave() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to save?", callback: this.save };
        },
        save() {
            this.loading = true;
            let data = {
                ...this.data,
                lines: this.data.items,
                component_lines: this.data.components
            }
            landedCost.update(this.id, data).then(res => {
                this.$router.replace({
                    name: "LandedCostDisplay",
                    params: {
                        id: res.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }
}
</script>

<style>

</style>